<template>
  <div class="main" @click.self="$emit('closeModal')">
    <div class="box-modal">
      <span class="title">شناسایی دوعاملی</span>
      <p>
        با اسکن کد زیر می توانید از برنامه google authenticator به کد مربوط به صرافی دریک دسترسی داشته باشید
      </p>
      <div class="qr-code">
            <img
                        width="180px"
                        :src="'data:image/png;base64,'+qrCode"
                        alt="">
      </div>
      <p>
        پس از اسکن کد بالا، قسمت مربوطه به شناسایی دوعاملی دریک در Google authenticator شنما ایجاد خواد شد. کدی که در
        این بخش مشاهده می کنید را در کادر زیر وارد کنید
      </p>
  <CodeInput :loading="false"  v-on:complete="onComplete" @change="onChange"
                    ref="code-input"/>
      <div class="btn">
        <button @click="submit" class="blue-btn">تایید</button>
      </div>
    </div>
  </div>
</template>

<script>

import CodeInput from "vue-verification-code-input";
import {Copy,reset,paste} from "@/lib/reuseableFunction";
export default {
  name: "google-otp",
    props: ['twoStep', 'qrCode', 'qrLink','mobile'],
  components: {CodeInput},
    data() {
      return {
        close:false,
        disablebtn:true,
        amount: '',
        twostepcode: '',
        walletaddress: '0x40beE7b4e50d756C57B4e59693905D36B9cCD1B6',
        smscode: [],
        error: '',
        num: 6,
        otp:{
            code: '',
        },
        timeOut: '',
        countDown: 120,

      }
  },
  methods : {
      closeModale() {
        this.$emit('closeModal' , this.close)
      },
      onComplete() {
        this.disablebtn=false
        this.submit()
      },
    //   text() {
    //      
    //   }
    // countDownTimer() {
    //             if (this.countDown > 0) {
    //                 this.timeOut = setTimeout(() => {
    //                     this.countDown--
    //                     this.countDownTimer()
    //                 }, 1000)
    //             } else {
    //                 this.$error('زمان شما به اتمام رسید', '')
    //             }
    //         },
            // async send() {
            //     this.reset()
            //     this.state.loading = true
            //     const a = {
            //         EMAIL: 'ایمیل',
            //         SMS: 'شماره'
            //     }
            //     const res = await this.$axios.post(`/users/send-verification-code?twoStepAuthorization=EMAIL`)
            //     if (res.message === 'Verification Code Sent') {
            //         this.$error('', 'کد به ' + a['GOOGLE_AUTHENTICATOR'] + ' شما ارسال شد', 'success')
            //         if (this.countDown === 0)
            //             this.countDown = 120
            //         this.countDownTimer()
            //     }
            // },
            // close() {
            //     this.$emit('close');
            // },
            onChange(e) {
                this.otp.code = e
            },
            async submit() {
                const a = {
                    'EMAIL': 'ایمیل',
                    'SMS': 'پیامک',
                    'GOOGLE_AUTHENTICATOR': 'Google Authenticator'
                }
                if (this.otp.code.toString().length === 6) {
                    if (this.$route.name !== 'Wallet') {
                        this.state.loading = true
                        const [res,] = await this.$http.post(`/users/change-otp?twoStepAuthorization=GOOGLE_AUTHENTICATOR&code=${this.otp.code}`)
                        if(res){
                            this.reset()
                            this.$emit('close')
                            this.$emit('submit', 'شناسایی دو مرحله ای شما به ' + a['GOOGLE_AUTHENTICATOR'] + ' تغییر یافت.')
                        }
                    } else {
                        this.$emit('submit', this.otp.code)
                    }
                }
            },
            Copy, paste,reset

  },
  mounted() {
            this.$refs['code-input'].$refs['input_0'][0].focus()
            // if (this.twoStep !== 'GOOGLE_AUTHENTICATOR') this.countDownTimer()
            document.body.style.overflow = 'hidden'
        },
        beforeDestroy() {
            clearTimeout(this.timeOut)
            document.body.style.overflow = 'auto'
        },
}
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(0, 0, 0, 0.7);
  z-index: 10;

  .box-modal {
    background-color: rgba(11, 20, 38, 1);
    display: flex;
    flex-direction: column;
    color: #FFFFFF;
    border-radius: 16px;
    padding: 28px;
    width: 367px;
    font-size: clamp(14px, 2vw, 16px);
    height: 400px;
    overflow: auto;

    .btn{
      width: 100%;
      margin-top: 40px;

      button{
        width: 100%;
      }
    }

    .title {
      margin-bottom: 20px;
      font-weight: bold;
      text-align: center;
    }

    p {
      margin: 26px;
      text-align: right;
    }

    input {
      margin-bottom: 26px;
    }
  }
}

@media (max-width: 500px) {
  .box-modal {
    width: 240px !important;
  }
}
</style>